/**
 * Paso1.js
 * Escanear frente de tu DNI
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { osVersion, osName, mobileVendor } from "react-device-detect";
import $ from 'jquery';
import { onBoardingDigital } from '../../actions/actions';
import { setErrorMessage } from '../../actions/actions'

//material-ui
import Grid from '@material-ui/core/Grid';

// Components
import { IndicacionCamara } from './customModals/IndicacionCamara';
import Camara from './NuevaCamara';

//Assets
import dni from '../../static/img/dni.png';

//Services
import { processToken } from './services/tokenService';
import { processFlow } from './services/flowService';
import { storeUrlRiesgoNet } from './services/riesgoNetService';
import { processIdClientAnalytics } from './services/pixelService';

//actions
import { vuReintentos } from '../../actions/actions'

//por ahora lo llamo desde los utiles de plazo fijo, hay que mejorarlo y dejarlo en alguna carpeta que sea 
//generica para las dos carpetas (Onboarding y PlazoFijo)
import { traerConfiguracionBackend } from '../PlazoFijo/Utils/BackendUnificado';
import { Layout } from './layout/Layout';
import { VUCalls } from './services/VuService';

var ip = require('ip');

class Paso1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paso: 1,
            disabled: false,
        }
        //ref a camara
        this.camaraRef = createRef();
        //bindeos
        this.newOperacionVU = this.newOperacionVU.bind(this);
        this.validateFlow = this.validateFlow.bind(this);
        this.validateToken = this.validateToken.bind(this);
        this.setSiguientePaso = this.setSiguientePaso.bind(this);
        this.frontOperationVU = this.frontOperationVU.bind(this);
    }

    componentWillMount() {
        localStorage.removeItem('url');
        traerConfiguracionBackend(false, true)
            .then(res2 => {this.willMount()})
            .catch(err => {this.willMount()});
    }

    willMount() {
        this.validateFlow();
        this.validateToken();
        processIdClientAnalytics('paso-1')
    }

    componentDidMount() {
        $(".load").fadeOut(700);
        this.props.dispatch(
            vuReintentos(0)
        );
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history);
    }

    async newOperacionVU() {
        this.setState({ disabled: true })
        const newOperation = {
            userName: "UserPrueba",
            ipAddress: ip.address(),
            deviceHash: "hash",//TODO
            rooted: false,
            applicationVersion: "1.0.0",
            operativeSystem: osName,
            operativeSystemVersion: osVersion,
            deviceManufacturer: mobileVendor,
        };

        try {
            //Manejo imperativo del hijo
            //Necesitamos que este scope de ejecución del onClick() se propague para poder abrir la camara.
            this.camaraRef.current.handleClick();
            const response =  await VUCalls.operationSave(null, newOperation);
            if (response.data.code == 901) {
                //Exito, continuar al paso 2 (que no exite)
                processIdClientAnalytics('paso-2');
            } else if (sessionStorage.getItem('tipoFlujo') == null) {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-resolucion')
                });
            } else if (sessionStorage.getItem('tipoFlujo') != 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-servicio')
                });
            } else if (sessionStorage.getItem('tipoFlujo') == 'standalone') {
                console.error("error con la foto: ", response.data.code);
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-standalone')
                });
            }
        } catch (error) {
            // alert("vine por error");
            if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-resolucion')
                });

            } else if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    console.error("error con la foto: ", error.response.status);
                    this.props.history.push('/error-servicio')
                });
            } else {
                console.error("error con la foto: ", error.response.status);
                this.props.dispatch(
                    setErrorMessage(error.response.data.message)
                );
                if (error.response.data.message == null) {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-servicio')
                    });
                } else {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-validacion-imagen')
                    });
                }
            }
        }
    }

    //parentHandleImage
    frontOperationVU(image) {
        const frontOperation = {
            analyzeAnomalies: true,
            analyzeOcr: true    
        };
        let formData = new FormData();
        formData.append("file", image);
        formData.append('data', new Blob([JSON.stringify(frontOperation)], {
            type: "application/json"
        }));
        $(".load").fadeIn(700);
        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data: formData,
            url:  localStorage.getItem('url') + '/api/vu/frontOperation'
            })
        .then(response => {
            if (response.data.code === "909") {
                $(".load").fadeOut(700);
                this.setSiguientePaso();
                this.props.dispatch(
                    vuReintentos(0)
                );
                return this.props.history.push('/paso-3')
            
            // Nuevo If de validacion imagen horiontal
            } else if (response.data.code === "400") {
                console.error(response.data.message)
                //Mostrar mensaje de error
            } else if (!response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/sin-reintentos')
                });
            } else if (!response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-standalone')
                });
            }
        })
        .catch(error => {
            if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-standalone')
                });

            } else if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-servicio')
                });
            } else {
                this.props.dispatch(
                    setErrorMessage(error.response.data.message)
                );
                
                if (error.response.data && !error.response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/sin-reintentos')
                    });
                }else if (error.response.data && !error.response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-standalone')
                    });
                } else if (error.response.data.message == null && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-servicio')
                    });
                } else  if (error.response.data.message == null && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-standalone')
                    });
                } else {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-validacion-imagen')
                    });    
                }
            }
        })
    }

    setSiguientePaso() {
        this.props.dispatch(
            onBoardingDigital(this.state.paso + 1)
        );
    }

    render() {
        const header = {
            progress : {value : 25}
        };
        const footer = {
            button: {
                action : this.newOperacionVU,
                text : "escanear frente",
                disabled : this.state.disabled
            }
        };
        const body = {
            img : {
                src : dni
            },
            slot : <IndicacionCamara/>
        }

        return (
            <Layout header={header} footer={footer} body={body}
                tieneFooter>
                <Grid item xs={12} sm={12}>
                    <div className="content-description">
                        <h5 className="title" >Ubica el frente de tu DNI</h5>
                        <h5 className="title">centrado frente a la cámara</h5>
                        <h6 className="description">Asegurate de que haya suficiente luz y que los datos sean legibles.</h6>
                    </div>
                </Grid>
                <Camara ref={this.camaraRef} parentHandleImage={this.frontOperationVU} capture='user'/>
            </Layout>
        );
    }
}

export default connect()(Paso1);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/Paso1.js